









































import { Vue, Component } from 'vue-property-decorator'
import { Button, Header, CustomLink, Subheader, Container, Divider, BaseModal } from '../atoms/'
import {
  DisplayNameBox,
  ProfileImageBox,
  EmailBox,
  ChangePasswordBox,
  RiskProfileBox,
  SocialMappingBox,
  BackBox,
  CreatePasswordBox,
  ConsentBox
} from '../organisms'
import { mapActions, mapGetters } from 'vuex'

import {
  GET_PROFILE,
  PROFILE_MODULE,
  USER_ID,
  DISPLAYNAME,
  EMAIL,
  PROFILE_URL,
  ACTIVATE,
  UNIQUE_ID,
  ALLOW_CHANGE_EMAIL,
  PROVIDERS,
  RISK_PROFILE,
  PROFILE_IMAGE,
  NEW_EMAIL,
  TEL
} from '../../store/modules/profile/constant'

@Component({
  components: {
    Button,
    Container,
    Header,
    CustomLink,
    Subheader,
    Divider,
    DisplayNameBox,
    ProfileImageBox,
    EmailBox,
    ChangePasswordBox,
    RiskProfileBox,
    SocialMappingBox,
    BackBox,
    CreatePasswordBox,
    BaseModal,
    ConsentBox
  },
  computed: {
    ...mapGetters(PROFILE_MODULE, [
      USER_ID,
      DISPLAYNAME,
      EMAIL,
      PROFILE_URL,
      ACTIVATE,
      UNIQUE_ID,
      ALLOW_CHANGE_EMAIL,
      PROVIDERS,
      RISK_PROFILE,
      PROFILE_IMAGE,
      NEW_EMAIL,
      TEL
    ])
  },
  methods: {
    ...mapActions(PROFILE_MODULE, [GET_PROFILE])
  }
})
export default class Profile extends Vue {
  queryError = ''
  modalQueryError = false
  mounted() {
    this.queryError = this.$route.query.error as string
    if (this.queryError && this.queryError != '') {
      this.modalQueryError = true
    }
    return (this as any)[GET_PROFILE]('')
  }
  get email(): string {
    return (this as any)[EMAIL]
  }
  get tel(): string {
    return (this as any)[TEL] || 'ไม่มีข้อมูล'
  }
  get newEmail() {
    return (this as any)[NEW_EMAIL]
  }
  get displayName() {
    return (this as any)[DISPLAYNAME]
  }
  get riskProfile(): string {
    return (this as any)[RISK_PROFILE]
  }
  get providers(): Array<any> {
    return (this as any)[PROVIDERS]
  }
  get profileImage() {
    return (this as any)[PROFILE_IMAGE]
  }
  get allowChangeEmail(): boolean {
    return (this as any)[ALLOW_CHANGE_EMAIL]
  }
  get activate(): boolean {
    return (this as any)[ACTIVATE]
  }
  get notificationURL() {
    return (process?.env?.VUE_APP_FINNO_ENDPOINT || 'https://www.finnomena.com') + '/notification/settings'
  }
}
